import React, { useState } from "react";
import ModalEditReference from "./ModalEditReference";

const WrapModalEdit = ({ children, ...props}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () =>  {
    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      {children({ onOpen: handleOpen })}
      {open && 
        <ModalEditReference
          isOpen={open}
          toggleModal={handleClose}
          {...props}
        >
        </ModalEditReference>
      }
    </>
  )
}

export default WrapModalEdit
